"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class RepairArticleController {
    constructor(mongoIdIdentifier, addButtonIdentifier, filteredHandle) {
        this.addButtonIdentifier = addButtonIdentifier;
        this.filteredHandle = filteredHandle;
        if (!window.location.href.includes("car-repairs-tutorial"))
            return;
        const mongoDocumentIDElm = document.querySelector(mongoIdIdentifier);
        this.mongoDocumentID = mongoDocumentIDElm.dataset.id;
        this.initRepairArticle();
    }
    initRepairArticle() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.getMongoProducts();
            yield this.callProductPromises();
            this.productDataArray = this.filterProducts(this.returnProductDataArray());
            const cards = this.returnShopifyProductCard();
            this.renderShopifyProductCards(cards);
            RepairArticleController.renderPenSelect(this.hasMarker, '#addToCart__button');
            this.initBulkAddButton();
        });
    }
    initBulkAddButton() {
        if (!this.productDataArray)
            return;
        const initBulkAddButton = new BulkAddToCartController(this.productDataArray, this.addButtonIdentifier);
    }
    renderShopifyProductCards(cards) {
        if (!cards)
            return;
        const target = document.querySelector('#addToCart__block');
        const cardElms = cards.map((el) => {
            const cardElm = el.createCard();
            target.insertAdjacentElement('afterbegin', cardElm);
            return cardElm;
        });
    }
    static renderPenSelect(hasMarker, targetSelector) {
        if (!hasMarker)
            return;
        const elm = this.returnPenSelectorClone();
        const target = document.querySelector(targetSelector);
        target === null || target === void 0 ? void 0 : target.insertAdjacentElement('afterend', elm);
    }
    returnShopifyProductCard() {
        if (!this.productDataArray)
            return;
        const renderMap = new Map();
        renderMap.set('title', { identifier: 'p', attribute: 'innerText' });
        renderMap.set('image_X200', { identifier: 'img', attribute: 'src' });
        renderMap.set('url', { identifier: 'a', attribute: 'href' });
        const cards = this.productDataArray.map((el) => {
            const cardClone = this.returnProductCardClone();
            const cardOptions = {
                variantSelector: { on: false },
                targetElm: cardClone,
                renderMap: renderMap
            };
            const productCardObject = new MoobiProductCard(el, cardOptions);
            return productCardObject;
        });
        return cards;
    }
    returnProductDataArray() {
        if (!this.shopifyProductResponses)
            return;
        const productDataArray = this.shopifyProductResponses.map((el) => {
            const data = MoobiAdaptors.adaptorShopifyProductResponseToData(el.product);
            this.addQuantityToProductData(data);
            return data;
        });
        return productDataArray;
    }
    filterProducts(dataArray) {
        if (dataArray === undefined)
            return;
        const filtered = dataArray.filter((el) => {
            let result = true;
            this.filteredHandle.forEach((el_01) => {
                if (el_01 === el.handle) {
                    result = false;
                    this.hasMarker = true;
                }
            });
            return result;
        });
        return filtered;
    }
    callProductPromises() {
        return __awaiter(this, void 0, void 0, function* () {
            const handleArray = this.returnHandlesArray();
            if (!handleArray)
                return;
            const promises = handleArray.map((el) => {
                const promise = moobiQueries.getProductDataByHandle(el);
                return promise;
            });
            this.shopifyProductResponses = yield Promise.all(promises);
        });
    }
    getMongoProducts() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.mongoDocumentID)
                return;
            const mongoData = yield moobiQueries.getMongoSolutionById(this.mongoDocumentID);
            this.mongoProducts = mongoData.data.navis[0].product;
        });
    }
    returnProductCardClone() {
        const cardHTML = `<div class="article__section__meta__addToCart__item">
            <div class = "article__section__meta__addToCart__item__imageWrapper imageSkeleton">
                <a href="/products/silicone-off-300">
                    <img src="https://cdn.shopify.com/s/files/1/0046/0990/0618/products/99gong-fang-qiang-li-tuo-zhi-ji-silicone-off-300-che-shen-bao-yang-body-maintenance-soft-99-468122_200x200.jpg?v=1606972568">
                </a>
            </div>
            <div class = "article__section__meta__addToCart__item__content">
                <p>99工房 強力脫脂劑 Silicone Off 300</p>
            </div>
        </div>`;
        const parser = new DOMParser();
        const cardClone = parser.parseFromString(cardHTML, 'text/html').querySelector('.article__section__meta__addToCart__item');
        return cardClone;
    }
    static returnPenSelectorClone() {
        const template = document.getElementById('penColorSection');
        var clone = document.importNode(template.content, true);
        const elm = clone.querySelector('.penColor_select_section_grid');
        return elm;
    }
    addQuantityToProductData(data) {
        if (!this.mongoProducts)
            return;
        const dataCopy = data;
        this.mongoProducts.forEach((el) => {
            if (el.productHandle === data.handle) {
                dataCopy.quantity = el.quantity;
            }
        });
        return dataCopy;
    }
    returnHandlesArray() {
        if (this.mongoProducts) {
            const products = this.mongoProducts;
            const handlesArray = products.map((el) => {
                return el.productHandle;
            });
            return handlesArray;
        }
    }
}
class WisdomPenSelectorController {
    constructor(penHolderId) {
        this.penHolderId = penHolderId;
        if (!window.location.href.includes("wisdom-repairs"))
            return;
        this.init();
    }
    ifPenWisdom() {
        let isPenWisdom = false;
        const wisdomHandles = ["car-body-stone-repair-001", "car-body-repairs-diy-001", "paint-color-guide-001"];
        wisdomHandles.forEach((el) => {
            if (!isPenWisdom)
                return;
            if (window.location.href.includes(el)) {
                console.log("ispenwisdom");
                isPenWisdom = true;
            }
        });
        return isPenWisdom;
    }
    init() {
        this.isPenWisdom = this.ifPenWisdom();
        if (!this.isPenWisdom) {
            return;
        }
        const penSelector = RepairArticleController.returnPenSelectorClone();
        RepairArticleController.renderPenSelect(this.isPenWisdom, this.penHolderId);
    }
}
const repairArticleController = new RepairArticleController('#dbDocumentId', '#addToCart__button', ["atelier-99-touch-up-pen"]);
const repairWisdomPenSelector = new WisdomPenSelectorController("#penselectorHolder");
